import { render, staticRenderFns } from "./freeOrderDetail.vue?vue&type=template&id=45b4ed5f&scoped=true&"
import script from "./freeOrderDetail.vue?vue&type=script&lang=js&"
export * from "./freeOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./freeOrderDetail.vue?vue&type=style&index=0&id=45b4ed5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b4ed5f",
  null
  
)

export default component.exports